export function getModuleLabel(module) {
  if (typeof module === 'string') {
    return module;
  }

  return module?.name || module?.code || module?.moduleCode || '';
}

export function normalizeModuleKey(module) {
  return getModuleLabel(module).trim().toUpperCase().replace(/\s+/g, ' ');
}

function toCreditNumber(value) {
  if (value === '' || value === null || value === undefined) {
    return null;
  }

  const credits = Number(value);
  return Number.isFinite(credits) && credits >= 0 ? credits : null;
}

function toTargetCreditNumber(value) {
  const credits = toCreditNumber(value);
  return credits !== null && credits > 0 ? credits : null;
}

export function getModuleCreditValue(module) {
  const directCreditValue = module && typeof module === 'object'
    ? module.credits ?? module.credit ?? module.moduleCredits ?? module.nqfCredits ?? module.creditValue
    : null;

  return toCreditNumber(directCreditValue);
}

export function getModuleCreditValueFromMap(module, moduleCredits = {}) {
  const moduleKey = normalizeModuleKey(module);

  if (moduleKey && Object.prototype.hasOwnProperty.call(moduleCredits, moduleKey)) {
    return toCreditNumber(moduleCredits[moduleKey]);
  }

  if (!module || typeof module !== 'object') {
    return null;
  }

  return getModuleCreditValue(module);
}

export function getModuleCredits(modules = [], moduleCredits = {}) {
  if (!Array.isArray(modules)) {
    return [];
  }

  return modules.map(module => ({
    key: normalizeModuleKey(module),
    name: getModuleLabel(module) || 'Unnamed module',
    credits: getModuleCreditValueFromMap(module, moduleCredits)
  }));
}

export function getKnownCreditsTotal(modules = [], moduleCredits = {}) {
  return modules.reduce((sum, module) => {
    const credits = getModuleCreditValueFromMap(module, moduleCredits);
    return credits === null ? sum : sum + credits;
  }, 0);
}

export function getKnownCreditsCount(modules = [], moduleCredits = {}) {
  return modules.filter(module => getModuleCreditValueFromMap(module, moduleCredits) !== null).length;
}

export function getTargetCredits(profile, globalSettings) {
  const university = profile?.university || {};
  const levelOfStudy = university.levelOfStudy;
  const profileTarget = toTargetCreditNumber(
    university.targetCredits ??
    university.graduationCredits ??
    university.creditsRequired ??
    university.courseCredits
  );

  if (profileTarget !== null) {
    return profileTarget;
  }

  const settingsTarget = toTargetCreditNumber(
    globalSettings?.academicCredits?.targetCreditsByLevel?.[levelOfStudy] ??
    globalSettings?.academicCredits?.targetCredits ??
    globalSettings?.creditTargets?.[levelOfStudy]
  );

  if (settingsTarget !== null) {
    return settingsTarget;
  }

  return null;
}

export function formatCredits(credits) {
  return credits === null ? 'Not set' : `${credits} credits`;
}
